import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/live/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/planner/live/table',
      params,
    });
  },
});
